var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ht-query-sql-preview',{attrs:{"view-id":_vm.viewId}})}
var staticRenderFns = []

export { render, staticRenderFns }